import { Markdown, Typography } from '@mgmresorts/wcl-lab';
import React, { ReactElement, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { Warning } from './icons/Warning';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 12px 16px;

  width: 100%;
  min-height: 48px;

  /* Core/errorRed */

  &.error {
    border: 1px solid #e02d21;

    svg {
      fill: #e02d21;
      path {
        fill: #e02d21;
      }
    }

    a span {
      color: #000 !important;
      font-weight: 600;
    }
  }

  &.info {
    border: 1px solid #373ae5;
    background-color: #f4f3fc;

    svg {
      fill: #373ae5;
      path {
        fill: #373ae5;
      }
    }
  }

  box-sizing: border-box;
  border-radius: 8px;

  /* Inside Auto Layout */
  flex: none;
  flex-grow: 0;
  margin: ${(p: { marginBottom?: string; marginTop?: string }) => `${p.marginTop} 0 ${p.marginBottom} 0`};

  .identity__alert-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    padding: 0;
    flex: none;
    order: 1;
    flex-grow: 0;
    line-height: 24px;
    word-break: break-word;
    max-width: calc(100% - 24px);
    color: #00012b;
  }
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 6px 8px 0px 0px;
`;

export const Alert = (props: {
  text: string;
  marginBottom?: string;
  marginTop?: string;
  type?: 'error' | 'info';
  children?: ReactElement;
  testId?: string;
}) => {
  const { type = 'error', marginBottom = '32px', marginTop = '0', testId, ...rest } = props;
  const ref: React.RefObject<HTMLInputElement> = useRef(null);

  useEffect(() => {
    window.scroll({
      top: calculateTop(ref.current?.offsetTop),
      behavior: 'smooth',
    });
  }, []);

  return (
    <Container
      marginBottom={marginBottom}
      marginTop={marginTop}
      className={type}
      ref={ref}
      data-testid={testId}
      {...rest}
    >
      <IconWrapper>
        <Warning />
      </IconWrapper>
      {props.children ? (
        <Typography variant='paragraph' className='identity__alert-text'>
          {props.text}
          {props.children}
        </Typography>
      ) : (
        <Markdown paragraphProps={{ variant: 'paragraph' }} className='identity__alert-text'>
          {props.text}
        </Markdown>
      )}
    </Container>
  );
};

function calculateTop(offsetTop?: number): number {
  return offsetTop ? offsetTop - 100 : 0;
}
